import React, { useState } from "react";
import { Paper } from "@material-ui/core";
import dashboardStyle from "../Layout/DashboardStyle";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import { Container, Grid, Typography } from "@mui/material";
import Orders from "./Order";
import Title from "../Layout/Title";

export default function Home() {
  const classes = dashboardStyle();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Grid container className={classes.root}>
      <Header mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      <main>
        <div className={classes.toolbar} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3} p={3}>
            <Grid item xs={4}>
              <Paper className={classes.gridPadding}>
                <Title>Customers</Title>
                <Typography component="p" variant="h4">
                  5
                </Typography>
                <Typography
                  color="textSecondary"
                  className={classes.depositContext}
                >
                  Since last month
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.gridPadding}>
                <Title>Orders</Title>
                <Typography component="p" variant="h4">
                  5
                </Typography>
                <Typography
                  color="textSecondary"
                  className={classes.depositContext}
                >
                  Since last month
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.gridPadding}>
                <Title>Payment</Title>
                <Typography component="p" variant="h4">
                  1,274
                </Typography>
                <Typography
                  color="textSecondary"
                  className={classes.depositContext}
                >
                  Since last month
                </Typography>
              </Paper>
            </Grid>

            {/* Recent Orders */}
            <Grid item xs={12}>
              <Paper className={classes.gridPadding}>
                <Orders />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Grid>
  );
}
